konnyScript(function($){

  /*스타일링 팁 슬라이드_25FW*/
  $('[id^=\'style_25fw_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var style25fwSlide = new Swiper(this,{
        slidesPerView:'auto',
        slidesPerGroup:1,
        spaceBetween:'2.9%',
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop: true,
        pagination:true,
        pagination:{
          el:slidePage1,
          clickable:true,
        },
        scrollbar:{
          el:slideScr,
          hide:true,
        },
    });
  });

  /*몰컷 슬라이드_25FW*/
  $('[id^=\'mall_25fw_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var style25fwSlide = new Swiper(this,{
        slidesPerView:'auto',
        slidesPerGroup:1,
        spaceBetween:'2.9%',
        centeredSlides:false,
        observer:true,
        observeParents:true,
        //loop: true,
        pagination:true,
        pagination:{
          el:slidePage1,
          clickable:true,
        },
        scrollbar:{
          el:slideScr,
          hide:true,
        },
    });
  });
  
  var styletipSlide = new Swiper('#styletip_swiper_slide1',{
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      //loop: true,
      scrollbar: {
          el: '#styletip_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el: '#styletip_swiper_slide1 .swiper-pagination',
      },
      navigation: {
          nextEl: '#styletip_swiper_slide1 .swiper-button-next',
          prevEl: '#styletip_swiper_slide1 .swiper-button-prev',
      },
  });
  
  var sTipSlide = new Swiper('#sTip_swiper_slide1',{
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 10,
    //loop: true,
    scrollbar: {
      el: '#sTip_swiper_slide1 .swiper-scrollbar',
    },
    pagination: {
      el: '#sTip_swiper_slide1 .swiper-pagination',
    },
    navigation: {
      nextEl: '#sTip_swiper_slide1 .swiper-button-next',
      prevEl: '#sTip_swiper_slide1 .swiper-button-prev',
    },
  });
  
  var spcSlide = new Swiper('#spc_swiper_slide1',{
    centeredSlides: true,
    speed:0,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination:true,
    pagination:{
      el:'#spc_swiper_slide1 .swiper-pagination',
        clickable:true,
    },
    scrollbar:{
      el:'#spc_swiper_slide1 .swiper-scrollbar',
      hide:true,
    },
  });
  
  /* 뉴컬러 화보 슬라이드 */
  $('[id^=\'nc_swiper_slide\']').each(function(index){
    index = index+1;
    var slidePage1 = this.querySelector('.swiper-pagination');
    var slidePage2 = this.querySelector('.swiper-progress');
    var slideScr = this.querySelector('.swiper-scrollbar');
    var slideNext = this.querySelector('.swiper-button-next');
    var slidePrev = this.querySelector('.swiper-button-prev');
    var reviewSlide = new Swiper(this,{
      slidesPerView:1.19,
      slidesPerGroup:1,
      spaceBetween :'3%',
      centeredSlides:true,
      observer:true,
      observeParents:true,
      //loop: true,
      pagination:true,
      pagination:{
        el:slidePage1,
        clickable:true,
      },
      scrollbar:{
        el:slideScr,
        hide:true,
      },
    });
  });

  $('[id^=\'mall_swiper_slide\']').each(function(index){
      index = index+1;
      var slidePage1 = this.querySelector('.swiper-pagination');
      var slidePage2 = this.querySelector('.swiper-progress');
      var slideScr = this.querySelector('.swiper-scrollbar');
      var slideNext = this.querySelector('.swiper-button-next');
      var slidePrev = this.querySelector('.swiper-button-prev');
      var mallSlide = new Swiper(this,{
          slidesPerView:1.19,
          slidesPerGroup:1,
          spaceBetween:'3%',
          centeredSlides:true,
          scrollbar:{
              el:slideScr,
              hide:true,
          },
          navigation: {
              nextEl: slideNext,
              prevEl: slidePrev,
          },
      });
  });

  $('[id^=\'w_swiper_slide\']').each(function(index){
      index = index+1;
      var slidePage1 = this.querySelector('.swiper-pagination');
      var slidePage2 = this.querySelector('.swiper-progress');
      var slideScr = this.querySelector('.swiper-scrollbar');
      var slideNext = this.querySelector('.swiper-button-next');
      var slidePrev = this.querySelector('.swiper-button-prev');
      var mallSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          centeredSlides:true,
          scrollbar:{
              el:slideScr,
              hide:true,
          },
      });
  });
    
  $('#k-prdWrap .conInfoWrap .conTop').click(function(){
    var onDiv = $(this).parents('.conInfoWrap');
    onDiv.toggleClass('on');
  });
  
  /* gif 슬라이드 */
  $('[id^=\'gif_swiper_slide\']').each(function(index){
    var gifSlide = new Swiper(this,{
      slidesPerView:1,
      slidesPerGroup:1,
      loop:true,
      effect:'fade',
      speed:0,
      autoplay:{
        delay:600,
        disableOnInteraction:false,
      },
    });
  });
    
  $('[id^=\'gif_swiperslide\']').each(function(index){
      var gifSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          loop:true,
          effect:'fade',
          speed:700,
          autoplay:{
              delay:700,
              disableOnInteraction:false,
          },
      });
  });
  
  //전체싱품보기
  var allprdSlide = new Swiper('#k-prdWrap #allprd_swiper_slide',{
      slidesPerView:2.1,
      slidesPerGroup:1,
      spaceBetween:15,
      centeredSlides:false,
      observer:true,
      observeParents:true,
      //loop:true,
  });

  
    var gift_galleryTop = new Swiper('#setimg_swiper_slide1', {
        slidesPerView:1.02,
        slidesPerGroup:1,
        spaceBetween:10,
        pagination: {	//페이징 사용자 설정
            el: ".swiper-pagination",	//페이징 태그 클래스 설정 
            clickable: true,	//버튼 클릭 여부
            type : 'bullets',	//페이징 타입 설정(종류: bullets, fraction, progress, progressbar)
            // Bullet Numbering 설정
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },
        loop: false,	//슬라이드 반복
    });

    var swiper = new Swiper("#con_swiper_slide1", {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      loop: false,
      scrollbar: {
          el: '#con_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el: '#con_swiper_slide1 .swiper-pagination',
      },
      navigation: {
          nextEl: '#con_swiper_slide1 .swiper-button-next',
          prevEl: '#con_swiper_slide1 .swiper-button-prev',
      },
  });
  
    //세트 연동 슬라이드
    var swiperTopNum = $('#setimg_swiper_slide1').find('.swiper-slide');
    var swiperSubNum = $('#settxt_swiper_slide1').find('.gallery-thumbs');

    var galleryTop = new Swiper('#setimg_swiper_slide1', {
        slidesPerView:1,
        slidesPerGroup:1,
        pagination: {	//페이징 사용자 설정
            el: ".swiper-pagination",	//페이징 태그 클래스 설정 
            clickable: true,	//버튼 클릭 여부
            type : 'bullets',	//페이징 타입 설정(종류: bullets, fraction, progress, progressbar)
            // Bullet Numbering 설정
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },
        loop: false,	//슬라이드 반복
        loopedSlides: swiperTopNum.length	//loop 시 파라미터 duplicate 개수 - 정적으로 숫자 4 표현 가능
    });

    var galleryThumbs = new Swiper('#settxt_swiper_slide1', {
        slidesPerView:1,
        slidesPerGroup:1,
        effect:'fade',
        navigation: {	//네비게이션 사용자 설정
            nextEl: '.swiper-button-next',	//다음 버튼 클래스 설정
            prevEl: '.swiper-button-prev',	//이전 버튼 클래스 설정
        },
        centeredSlides: true,	//슬라이드 중앙 배치
        touchRatio: 0.2,	//드래그 비율 설정(기본값: 1, 기본값을 0으로 설정할 경우 드래그 불가능)
        slideToClickedSlide: true,	//슬라이드가 여러개 나열되어 있을 경우, 클릭 시 해당 슬라이드 위치로 이동
        loop: false,	//슬라이드 반복
        loopedSlides: swiperSubNum.length //loop 시 파라미터 duplicate 개수 - 정적으로 숫자 4 표현 가능
    });

    //Main Swiper와 Thumbnail Swiper가 연동제어 서로를 제어
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;
    
  
});